<div id="wrapperBoard">
    <canvas *ngIf="file" #canvas style="display: none;"></canvas>
    <img *ngIf="file" #image style="display: none;" [src]="file.urlSanitize">
    <iframe #iframe></iframe>
</div>